import {  axiosAjaxCall } from './common.service'
import {  showLoader } from "../../helpers";

export const ExceptionLogService = {
    getExceptionLogs
}

function getExceptionLogs(data) {
    
    showLoader();    
    return axiosAjaxCall("get_exception_logs_details", data);
}